import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';

function Email_enrichment_popup(props){

  function onSubmit(params){
    props.updateEmailEnrichment(params);
  }

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={(props.email_enrichment==undefined)?null:{...props.email_enrichment}}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='email_enrichment_popup_title' content={
          <Grid container style={{marginTop:'20px', marginBottom:'20px'}}>
            <Grid item xs={1}><IconButton><img style={{height:'20px'}} src='/images/icons/tomba.png'/></IconButton></Grid><Grid item xs={5}><Text title='Tomba api key' name='tomba_api_key'/></Grid><Grid item xs={5}><Text title='Tomba secret key' name='tomba_secret_key'/></Grid><Grid item xs={1}/>
            </Grid>
        }/>
        </form>
      )}
    </Form>
  );
}

//<Grid item xs={1}><IconButton><img style={{height:'20px'}} src='/images/icons/hunter.png'/></IconButton></Grid><Grid item xs={10}><Text title='Hunter' name='hunter'/></Grid><Grid item xs={1}/>
//<Grid item xs={1}><IconButton><img style={{height:'20px'}} src='/images/icons/dropcontact.png'/></IconButton></Grid><Grid item xs={10}><Text title='Dropcontact' name='dropcontact'/></Grid><Grid item xs={1}/>



export default connect(ss, dd)(Email_enrichment_popup);

function ss(state){
  return{
    email_enrichment:state.integrations.email_enrichment
  }
}

function dd(dispatch){
  return{
    updateEmailEnrichment:(params)=>{dispatch({type:'REQUEST_UPDATE_EMAIL_ENRICHMENT_API_KEYS', payload:params})}
  }
}
